import { defineStore } from "pinia";
import { ref } from "vue";
import config from "@/config";
import { captureException, getActiveMatchingSurveys } from "@/plugins/posthog";
import { SURVEYS_TTL } from "@/constants";

export const useSurveysStore = defineStore(
  "surveys",
  () => {
    const activeMatchingSurveys = ref([]);
    const answeredSurveys = ref([]);
    const fetchedSurveysTimestamp = ref(undefined);

    const storeSurveyAnswer = (surveyId) => {
      answeredSurveys.value.push(surveyId);
    };

    const getSurveys = async () => {
      const isCacheValid =
        fetchedSurveysTimestamp.value &&
        Date.now() - fetchedSurveysTimestamp.value < SURVEYS_TTL;

      if (!isCacheValid) {
        try {
          const surveys = await getActiveMatchingSurveys();

          activeMatchingSurveys.value = surveys;
          fetchedSurveysTimestamp.value = Date.now(); // Update timestamp after fetching
        } catch (ex) {
          console.error("Failed to fetch surveys from PostHog:", ex);
          captureException(ex);
        }
      }

      const filteredSurveys = activeMatchingSurveys.value.filter(
        (survey) =>
          survey.id !== config.posthog.churnSurveyId &&
          !answeredSurveys.value.includes(survey.id)
      );
      return filteredSurveys;
    };

    const resetSurveys = () => {
      answeredSurveys.value = [];
      fetchedSurveysTimestamp.value = 0;
    };

    return {
      activeMatchingSurveys,
      answeredSurveys,
      getSurveys,
      storeSurveyAnswer,
      resetSurveys,
      fetchedSurveysTimestamp,
    };
  },
  {
    persist: {
      paths: [
        "answeredSurveys",
        "fetchedSurveysTimestamp",
        "activeMatchingSurveys",
      ],
    },
  }
);
